module.exports = __webpack_public_path__ + "static/media/blog-image.a91d38e1.jpg";